import React from 'react';
import { motion } from 'motion/react';
import { Store, TrendingUp, Calendar, ArrowRight } from 'lucide-react';
import SEO from '../../components/SEO';
import { Link } from 'react-router-dom';

const SmallBusiness = () => {
  return (
    <div className="pt-24 pb-24 bg-[#030303] min-h-screen">
      <SEO 
        title="AI Social Media Manager for Small Businesses - PlataPost"
        description="Help your small business grow with PlataPost's AI social media manager. Save time, stay consistent, and attract more customers automatically."
      />

      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-20 mb-40">
          <div className="flex-1 space-y-8">
            <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full glass-card border border-white/5 text-indigo-400 text-[10px] font-black uppercase tracking-widest leading-none">
              <Store className="w-3.5 h-3.5" />
              <span>Small Business Focused</span>
            </div>
            <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight tracking-tighter">Social Media for <br /> <span className="text-indigo-500">Small Business.</span></h1>
            <p className="text-xl text-gray-400 mb-8 leading-relaxed font-medium">
              You're busy running a business. Let PlataPost run your social media. We help you stay consistent, professional, and engaging without the burnout.
            </p>
            <Link to="/dashboard" className="inline-flex px-10 py-5 bg-indigo-600 text-white rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-indigo-700 transition-all shadow-2xl shadow-indigo-600/30">
               Start Growing My Brand
            </Link>
          </div>
          <div className="flex-1 w-full glass-card rounded-[4rem] p-12 flex items-center justify-center border border-white/5 relative overflow-hidden group shadow-2xl shadow-indigo-600/5">
             <div className="absolute inset-0 bg-indigo-600/5 blur-[100px] pointer-events-none" />
             <div className="p-10 bg-white/5 rounded-3xl border border-white/10 shadow-2xl relative z-10 group-hover:scale-105 transition-transform duration-700">
                <div className="w-16 h-16 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center mb-6 text-indigo-400 shadow-xl shadow-indigo-600/10">
                  <Store className="w-8 h-8" />
                </div>
                <h3 className="text-2xl font-black text-white mb-3 tracking-tight">Local Coffee Shop</h3>
                <p className="text-gray-400 font-medium mb-6 leading-relaxed italic">"PlataPost saved me 10 hours a week on content creation."</p>
                <div className="h-2 w-full bg-white/5 rounded-full overflow-hidden">
                  <motion.div 
                    initial={{ width: 0 }}
                    animate={{ width: "100%" }}
                    transition={{ duration: 3, repeat: Infinity }}
                    className="h-full bg-indigo-500"
                  />
                </div>
             </div>
          </div>
        </div>

        <section className="mb-40">
          <div className="text-center mb-24 space-y-4">
            <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tighter leading-tight">Your New Marketing Partner</h2>
            <p className="text-gray-400 font-medium max-w-xl mx-auto">Helping your business stay active and relevant online.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
             {[
               { icon: TrendingUp, title: "Grow Revenue", desc: "Posts designed to drive traffic and sales for your products and services." },
               { icon: Calendar, title: "Auto-Consistency", desc: "Never go a week without posting. Keep your brand top-of-mind." },
               { icon: Store, title: "Local Presence", desc: "Targeted content that connects with your specific local community." }
             ].map((feature, i) => (
                <div key={i} className="p-12 glass-card rounded-[3rem] border border-white/5 hover:bg-white/5 transition-all group">
                   <div className="w-20 h-20 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center mb-10 text-indigo-400 group-hover:scale-110 group-hover:rotate-6 transition-all shadow-xl shadow-indigo-600/5">
                      <feature.icon className="w-10 h-10" />
                   </div>
                   <h3 className="text-3xl font-black text-white mb-6 tracking-tight">{feature.title}</h3>
                   <p className="text-gray-400 leading-relaxed font-medium">{feature.desc}</p>
                </div>
             ))}
          </div>
        </section>

        <div className="text-center glass-card rounded-[4rem] p-24 border border-white/5 relative overflow-hidden shadow-2xl shadow-indigo-600/5">
           <div className="absolute inset-0 bg-indigo-600/10 blur-[150px] pointer-events-none" />
           <h2 className="text-4xl lg:text-5xl font-black text-white mb-10 tracking-tighter">Get started for <span className="text-indigo-400">free.</span></h2>
           <Link to="/dashboard" className="relative z-10 inline-flex px-12 py-6 bg-indigo-600 text-white rounded-2xl font-black text-sm uppercase tracking-[0.2em] hover:bg-indigo-700 transition-all shadow-2xl shadow-indigo-600/30">
              Get Started for Free
           </Link>
        </div>
      </div>
    </div>
  );
};

export default SmallBusiness;
